import {
  FETCH_ALL_SPONSORS,
  FETCH_SPONSORS,
  DELETE_SPONSORS_SUCESS,
  DELETE_SPONSORS_ERROR,
  LOAD_EDIT_SPONSOR_DATA,
  OPEN_SPONSOR_MODAL,
  SPONSOR_SEARCH,
  SPONSORS_CATEGORIES,
  EDIT_SPONSOR_CATEGORY,
  UPDATED_SPONSOR_IMAGE,
  UPDATE_SPONSOR_FILES,
  SPONSOR_FILES_CHANGED,
  IMPORT_SPONSOR_MODAL,
  UPDATED_SPONSOR_BANNER,
  SPONSOR_WORKING_DYNAMIC_FORM,
  SPONSOR_COUNTING_NUMBERS,
} from "ActionsSponsors";

export function SponsorsReducers(state = [], action) {
  switch (action.type) {
    case FETCH_SPONSORS:
      return action.payload;
    case DELETE_SPONSORS_SUCESS:
      return "Sponsor deleted seccesfully.";
    case DELETE_SPONSORS_ERROR:
      return "Sponsor is related to event, Please delete event first.";
    case SPONSOR_SEARCH:
      return filterSponsors(action.payload.sponsors, action.payload.search);
    default:
      return state;
  }
}
export function AllSponsorsReducers(state = [], action) {
  switch (action.type) {
    case FETCH_ALL_SPONSORS:
      return action.payload;
    default:
      return state;
  }
}

export function SponsorCategoryReducers(state = [], action) {
  switch (action.type) {
    case SPONSORS_CATEGORIES:
      return action.payload;
    default:
      return state;
  }
}

export function SponsorCategoryEditReducers(state = {}, action) {
  switch (action.type) {
    case EDIT_SPONSOR_CATEGORY:
      return action.payload;
    default:
      return state;
  }
}

function filterSponsors(sponsors, search) {}

export function openSponsorPopup(state = [], action) {
  switch (action.type) {
    case OPEN_SPONSOR_MODAL:
      return action.payload.showModal;
    default:
      return state;
  }
}

export function loadEditSponsorData(state = {}, action) {
  switch (action.type) {
    case LOAD_EDIT_SPONSOR_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function sponsorImageReducer(state = null, action) {
  switch (action.type) {
    case UPDATED_SPONSOR_IMAGE:
      return action.payload;
    default:
      return state;
  }
}

export function sponsorBannerReducer(state = null, action) {
  switch (action.type) {
    case UPDATED_SPONSOR_BANNER:
      return action.payload;
    default:
      return state;
  }
}

export function sponsorFilesList(
  state = [
    { position: "file1", file: "", filename: "" },
    { position: "file2", file: "", filename: "" },
    { position: "file3", file: "", filename: "" },
    { position: "file4", file: "", filename: "" },
    { position: "file5", file: "", filename: "" },
  ],
  action
) {
  switch (action.type) {
    case UPDATE_SPONSOR_FILES:
      return action.payload;
    default:
      return state;
  }
}

export function sponsorFilesChanged(state = { ischanged: false }, action) {
  switch (action.type) {
    case SPONSOR_FILES_CHANGED:
      return action.payload;
    default:
      return state;
  }
}

export function importSponsorModal(state = [], action) {
  switch (action.type) {
    case IMPORT_SPONSOR_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function sponsorWorkingDynamicForm(state = null, action) {
  switch (action.type) {
    case SPONSOR_WORKING_DYNAMIC_FORM:
      return action.payload;
    default:
      return state;
  }
}

export function sponsorsCount(state = {}, action) {
  switch (action.type) {
    case SPONSOR_COUNTING_NUMBERS:
      return action.payload;
    default:
      return state;
  }
}
